
export function getDistanceFromLatLon([lat1,lon1],lat2,lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1);
  var a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c; // Distance in km
  return d.toFixed(1);
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}


export function getSportById(allSports, id){
  var foundsport = {};
   allSports.some(sport => {
     if(sport.sportId == id){
       foundsport = sport;
       return true;
     }
   });

  return foundsport;
}



export function getSportsName(allSports, sportsId){

  try{
      var sportsNameArray = [];
    sportsId.forEach(id => {
         allSports.list.some(sport => {
         if(sport.sportId == id){
           sportsNameArray.push(sport.name.split(" ").join("_"));
           return true;
         }
       });
    });
         return sportsNameArray;

  }catch(err){
    console.log(err);
    return [];
  }

}


export function checkIfArrayEqual(a, b){

   return a.sort().toString() == b.sort().toString() ? true :false;

}


export function checkEmail(value){
  let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
}



export function checkFunctionData(functionData){
  var bookEnabled = false;

  if(functionData.length > 0){

    functionData.some((data) => {

      if(data.type == 3 || data.type == 4){
        bookEnabled = true;
        return true;
      }

    });

  }else{

    return bookEnabled;
  }

  return bookEnabled;
}

export function checkBookingFunctionData(functionData){
  var bookEnabled = false;

  if(functionData.length > 0){

    functionData.some((data) => {

      if(data.type == 3){
        bookEnabled = true;
        return true;
      }

    });

  }else{

    return bookEnabled;
  }

  return bookEnabled;
}



// WEBPACK FOOTER //
// ./src/helperFunction/helper.js